import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3993831471/src/web/app/(publicScreens)/recipes/[slug]/RecipePageClient.tsx");
